import { Action } from 'redux';

import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface ForumFeedSubscribedFetchAction extends Action {
    readonly after: number; // Timestamp of the last post in the list - for infinity scroll
}
export const FEED_SUBSCRIBED_FETCH_REQUEST = 'FEED_SUBSCRIBED_FETCH_REQUEST';
export interface FeedSubscribedFetchRequestAction extends ForumFeedSubscribedFetchAction, APIRequestAction {
    readonly type: typeof FEED_SUBSCRIBED_FETCH_REQUEST;
}
export interface FeedSubscribedFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { posts: number[]; };
}
export const FEED_SUBSCRIBED_FETCH_SUCCESS = 'FEED_SUBSCRIBED_FETCH_SUCCESS';
export interface FeedSubscribedFetchSuccessAction extends ForumFeedSubscribedFetchAction, APISuccessAction<FeedSubscribedFetchNormalizedResponse> {
    readonly type: typeof FEED_SUBSCRIBED_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly notificationsOn: number[];
}
export const FEED_SUBSCRIBED_FETCH_FAILURE = 'FEED_SUBSCRIBED_FETCH_FAILURE';
export interface FeedSubscribedFetchFailureAction extends ForumFeedSubscribedFetchAction, APIFailureAction {
    readonly type: typeof FEED_SUBSCRIBED_FETCH_FAILURE;
}

export const feedSubscribedFetch = {
    request: (after: number): FeedSubscribedFetchRequestAction => ({
        type: FEED_SUBSCRIBED_FETCH_REQUEST, after,
    }),
    success: (after: number, hasNext: number, hasPrevious: number, notificationsOn: number[], response: FeedSubscribedFetchNormalizedResponse):
        FeedSubscribedFetchSuccessAction => ({
        type: FEED_SUBSCRIBED_FETCH_SUCCESS, after, hasNext, hasPrevious, notificationsOn, response,
    }),
    failure: (after: number, error: any): FeedSubscribedFetchFailureAction => ({
        type: FEED_SUBSCRIBED_FETCH_FAILURE, after, error,
    }),
};

// Feed subscribed load
export const FEED_SUBSCRIBED_LOAD = 'FEED_SUBSCRIBED_LOAD';
export interface FeedSubscribedLoadAction extends ForumFeedSubscribedFetchAction {
    readonly type: typeof FEED_SUBSCRIBED_LOAD;
}
export const feedSubscribedLoad = (after?: number): FeedSubscribedLoadAction => ({
    type: FEED_SUBSCRIBED_LOAD, after,
});
